/* ==================================================================
   North Shore Peptides — Age Gate behavior
   Remember verification · focus trap · decline handling
   In the theme editor the gate stays hidden until its section is
   selected, so merchants can still preview the rest of the page.
   ================================================================== */
(function () {
  'use strict';

  var KEY = 'np_age_verified_at';

  function isDesignMode() {
    return window.Shopify && window.Shopify.designMode;
  }

  function isVerified(days) {
    try {
      var stored = parseInt(window.localStorage.getItem(KEY) || '0', 10);
      if (!stored) return false;
      return (Date.now() - stored) < days * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('np-age-locked', on);
    document.body.classList.toggle('np-age-locked', on);
  }

  function initGate(gate) {
    if (!gate || gate.dataset.npInit === 'true') return;
    gate.dataset.npInit = 'true';

    var days = parseInt(gate.dataset.rememberDays || '30', 10);
    var confirmBtn = gate.querySelector('[data-age-confirm]');
    var declineBtn = gate.querySelector('[data-age-decline]');
    var redirectUrl = gate.dataset.declineUrl || '';
    var design = isDesignMode();
    var lastFocused = null;

    function onKeydown(e) {
      if (e.key !== 'Tab') return; // not Escape-dismissible
      var f = gate.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocused = document.activeElement;
      gate.removeAttribute('hidden');
      lockScroll(true);
      window.setTimeout(function () { if (confirmBtn) confirmBtn.focus(); }, 80);
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      gate.setAttribute('hidden', '');
      lockScroll(false);
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    // Handlers (wired in all modes)
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        try { if (!design) window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
        close();
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        if (redirectUrl) window.location.href = redirectUrl;
        else gate.dataset.declined = 'true';
      });
    }

    // Editor: keep hidden until the section is selected
    if (design) { gate.setAttribute('hidden', ''); return; }

    // Storefront: show unless already verified
    if (isVerified(days)) { gate.setAttribute('hidden', ''); return; }
    open();
  }

  function initAll() {
    document.querySelectorAll('.np-age').forEach(initGate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor controls
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.np-age');
    if (el) { el.dataset.npInit = ''; initGate(el); }
  });
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector('.np-age');
    if (el) el.removeAttribute('hidden');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var el = e.target.querySelector('.np-age');
    if (el) el.setAttribute('hidden', '');
  });
})();
